import React from 'react';
import AddNewItemComponent from './AddNewItemComponent';
import { useNavigate } from "react-router-dom";
function ExternalShareHandler(props) {

  const navigate = useNavigate();
  const url = new URL(document.location);
const sharedDescription = url.searchParams.get("description");
//const sharedLink = url.searchParams.get("link");

  function redirectToHome(){
    navigate("/");
  }

  return(
    <AddNewItemComponent onItemAdded={redirectToHome} showFollowUp="false" completed="false" area="PERSONAL"   contexturl={props.contexturl} initialText={sharedDescription}></AddNewItemComponent>
  )
}
export default ExternalShareHandler